"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WizardFrame = exports.WizardContent = exports.TitleLine = exports.StepperStyled = exports.StepperBlock = exports.Container = exports.ActionFlexContainer = void 0;

var _Stepper = _interopRequireDefault(require("@material-ui/core/Stepper"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FlexContainer = _interopRequireDefault(require("../FlexContainer"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TitleLine = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    display: flex;\n    padding: 8px;\n    align-items: baseline;\n    justify-content: flex-start;\n    & span {\n        font-weight: 300;\n        margin-left: 4px;\n    }\n"])));

exports.TitleLine = TitleLine;
var WizardFrame = (0, _styledComponents.default)(_FlexContainer.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n    background-color: white;\n"])), function (props) {
  return props.xl ? 'auto' : '800px';
}, function (props) {
  return props.xl && '100%';
});
exports.WizardFrame = WizardFrame;
var ActionFlexContainer = (0, _styledComponents.default)(_FlexContainer.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    background-color: ", "\n    min-height: 50px;\n    padding: 8px;\n"])), function (props) {
  return props.theme.colors.grey700;
});
exports.ActionFlexContainer = ActionFlexContainer;
var WizardContent = (0, _styledComponents.default)(_FlexContainer.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    min-width: 640px;\n    min-height: ", ";\n    padding: ", ";\n    width:", ";\n"])), function (props) {
  return !props.xl && '616px';
}, function (props) {
  return props.xl ? '1rem 0 0 0' : '1rem 0';
}, function (props) {
  return props.xl && '-webkit-fill-available';
});
exports.WizardContent = WizardContent;

var Container = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    height: 100%;\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    overflow-y: scroll;\n    & > div {\n        will-change: transform, opacity;\n        position: absolute;\n        width: 100%;\n        height: 100%;\n    }\n"])));

exports.Container = Container;
var StepperStyled = (0, _styledComponents.default)(_Stepper.default)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    && {\n        background-color: ", ";\n        padding: 16px;\n        width: 250px;\n        height: fit-content;\n        width: auto;\n        margin-top: 20%;\n    }\n"])), function (props) {
  return props.theme.colors.grey700;
});
exports.StepperStyled = StepperStyled;

var StepperBlock = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    height: ", ";\n    min-width: 160px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n"])), function (props) {
  return props.theme.colors.grey700;
}, function (props) {
  return props.xl ? '100%' : 'auto';
});

exports.StepperBlock = StepperBlock;